import React from 'react';
import { Outlet } from 'react-router-dom';
import CombinedMenu from '../components/CombinedMenu';

/**
 * Layout principal da aplicação.
 * Arquitetura: Outlet é o pai do conteúdo (não o menu).
 * O React Router determina o que renderizar via rotas; o CombinedMenu apenas envolve o Outlet.
 */
const MainLayout: React.FC = () => {
  return (
    <CombinedMenu>
      <Outlet />
    </CombinedMenu>
  );
};

export default MainLayout;
